<div
  class="px-3 pt-2 pb-1 text-xs font-semibold uppercase tracking-wider text-surface-400"
>
  {{ title() }}
</div>
